// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {LoginModalComponent} from '../../../../views/modules/auth/login-modal/login-modal.component';
import { MatDialog } from '@angular/material/dialog';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
	// intercept request and add token
	constructor(
		private toastr: ToastrService,
		public dialog: MatDialog){

	}
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// tslint:disable-next-line:no-debugger
		// modify request
		// request = request.clone({
		// 	setHeaders: {
		// 		Authorization: `Bearer ${localStorage.getItem('accessToken')}`
		// 	}
		// });


		return next.handle(request).pipe(
			tap(
				event => {
					if (event instanceof HttpResponse) {

						// http response status code

					}
				},
				error => {
					if (error.status == 401 && (error.error.message == 'Invalid JWT Token' || error.error.message == 'Expired JWT Token')) {

						// si aucune modal déja ouvert
						if(localStorage.getItem('authIsOpened') == null){
							// Mémoriser l'ouverture
							localStorage.setItem('authIsOpened','1');
							const dialogRef = this.dialog.open(LoginModalComponent, {
								disableClose: true,
								data: {},
								width: '500px'
							});
							dialogRef.afterClosed().subscribe(res => {
								if (!res) {
									return;
								}
								localStorage.removeItem('authIsOpened');
							});
						}

					}

				}
			)
		);
	}
}
